import { AmazonIcon } from '../../../assets/logo-color/Amazon.mjs';
import { AppleIcon } from '../../../assets/logo-color/Apple.mjs';
import { BinanceIcon } from '../../../assets/logo-color/Binance.mjs';
import { BitbucketIcon } from '../../../assets/logo-color/Bitbucket.mjs';
import { CoinbaseIcon } from '../../../assets/logo-color/Coinbase.mjs';
import { DiscordIcon } from '../../../assets/logo-color/Discord.mjs';
import { FacebookIcon } from '../../../assets/logo-color/Facebook.mjs';
import { FigmaIcon } from '../../../assets/logo-color/Figma.mjs';
import { GithubIcon } from '../../../assets/logo-color/Github.mjs';
import { GitlabIcon } from '../../../assets/logo-color/Gitlab.mjs';
import { GmailIcon } from '../../../assets/logo-color/Gmail.mjs';
import { GoogleIcon } from '../../../assets/logo-color/Google.mjs';
import 'react';
import { LinkedinIcon } from '../../../assets/logo-color/Linkedin.mjs';
import { MetamaskIcon } from '../../../assets/logo-color/Metamask.mjs';
import { MicrosoftIcon } from '../../../assets/logo-color/Microsoft.mjs';
import '../../../assets/logo.module.css.mjs';
import { OutlookIcon } from '../../../assets/logo-color/Outlook.mjs';
import { PhantomIcon } from '../../../assets/logo-color/Phantom.mjs';
import { SalesforceIcon } from '../../../assets/logo-color/Salesforce.mjs';
import { SlackIcon } from '../../../assets/logo-color/Slack.mjs';
import { SnapchatIcon } from '../../../assets/logo-color/Snapchat.mjs';
import { TiktokIcon } from '../../../assets/logo-color/Tiktok.mjs';
import { TwitchIcon } from '../../../assets/logo-color/Twitch.mjs';
import { XTwitterIcon } from '../../../assets/logo-color/XTwitter.mjs';
import { YahooIcon } from '../../../assets/logo-color/Yahoo.mjs';

const oauthIcons = {
    amazon: AmazonIcon,
    apple: AppleIcon,
    bitbucket: BitbucketIcon,
    coinbase: CoinbaseIcon,
    discord: DiscordIcon,
    facebook: FacebookIcon,
    figma: FigmaIcon,
    github: GithubIcon,
    gitlab: GitlabIcon,
    google: GoogleIcon,
    linkedin: LinkedinIcon,
    microsoft: MicrosoftIcon,
    salesforce: SalesforceIcon,
    slack: SlackIcon,
    snapchat: SnapchatIcon,
    tiktok: TiktokIcon,
    twitch: TwitchIcon,
    xTwitter: XTwitterIcon,
    yahoo: YahooIcon
};
const cryptoIcons = {
    phantom: PhantomIcon,
    metamask: MetamaskIcon,
    binance: BinanceIcon,
    coinbase: CoinbaseIcon
};
const emailIcons = {
    gmail: GmailIcon,
    outlook: OutlookIcon,
    yahoo: YahooIcon
};

export { cryptoIcons, emailIcons, oauthIcons };
//# sourceMappingURL=Icons.mjs.map
